import React, { useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { motion } from 'framer-motion';
const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return <header className="bg-white shadow-sm sticky top-0 z-50 border-b border-gray-100" data-id="element-169">
      <div className="container mx-auto px-4 py-3 flex justify-between items-center" data-id="element-170">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.5
      }} data-id="element-171">
          <a href="/" className="group" data-id="element-172">
            <img src="https://cdn.magicpatterns.com/uploads/oSaV23qaUxD7NPVqNZ7aig/logo_benefica_positivo.png" alt="Benefika" className="h-10 md:h-12 w-auto" data-id="element-173" />
          </a>
        </motion.div>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex space-x-8 items-center" data-id="element-174">
          <a href="/" className="text-benefika-charcoal hover:text-benefika-teal font-medium transition-colors" data-id="element-175">
            Inicio
          </a>
          <a href="/nosotros" className="text-benefika-charcoal hover:text-benefika-teal font-medium transition-colors" data-id="element-176">
            Nosotros
          </a>
          <a href="/#servicios" className="text-benefika-charcoal hover:text-benefika-teal font-medium transition-colors" data-id="element-177">
            Servicios
          </a>
          <a href="/#caracteristicas" className="text-benefika-charcoal hover:text-benefika-teal font-medium transition-colors" data-id="element-178">
            ¿Por qué elegirnos?
          </a>
          <a href="/programas-clientes" className="text-benefika-charcoal hover:text-benefika-teal font-medium transition-colors" data-id="element-179">
            Programas y Clientes
          </a>
          <a href="mailto:contacto@benefika.net" className="bg-benefika-teal hover:bg-benefika-emerald text-white px-5 py-2 rounded-full font-medium transition-all shadow-sm hover:shadow-md" data-id="element-180">
            Contactar
          </a>
        </nav>

        {/* Mobile Menu Button */}
        <button className="md:hidden text-benefika-charcoal p-2" onClick={() => setIsMenuOpen(!isMenuOpen)} aria-label="Toggle menu" data-id="element-181">
          {isMenuOpen ? <XIcon size={24} data-id="element-182" /> : <MenuIcon size={24} data-id="element-183" />}
        </button>
      </div>

      {/* Mobile Navigation */}
      {isMenuOpen && <motion.div initial={{
      opacity: 0,
      height: 0
    }} animate={{
      opacity: 1,
      height: 'auto'
    }} exit={{
      opacity: 0,
      height: 0
    }} className="md:hidden bg-white border-t border-gray-100 shadow-lg" data-id="element-184">
          <nav className="flex flex-col px-4 py-6 space-y-4" data-id="element-185">
            <a href="/" className="text-benefika-charcoal hover:text-benefika-teal font-medium text-lg transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-186">
              Inicio
            </a>
            <a href="/nosotros" className="text-benefika-charcoal hover:text-benefika-teal font-medium text-lg transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-187">
              Nosotros
            </a>
            <a href="/#servicios" className="text-benefika-charcoal hover:text-benefika-teal font-medium text-lg transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-188">
              Servicios
            </a>
            <a href="/#caracteristicas" className="text-benefika-charcoal hover:text-benefika-teal font-medium text-lg transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-189">
              ¿Por qué elegirnos?
            </a>
            <a href="/programas-clientes" className="text-benefika-charcoal hover:text-benefika-teal font-medium text-lg transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-190">
              Programas y Clientes
            </a>
            <a href="mailto:contacto@benefika.net" className="bg-benefika-teal text-white text-center px-4 py-3 rounded-md font-medium mt-4" onClick={() => setIsMenuOpen(false)} data-id="element-191">
              Contactar
            </a>
          </nav>
        </motion.div>}
    </header>;
};
export default Header;